export default [
  {
    path: "supply-notification/category",
    name: "SupplyNotificationCategory",
    component: () => import("@/pages/SupplyNotification/Category.vue"),
    meta: {
      title: "消息通知分类",
      requireAuth: true,
    },
  },
  {
    path: "supply-notification/manage",
    name: "SupplyNotificationManage",
    component: () => import("@/pages/SupplyNotification/Manage.vue"),
    meta: {
      title: "消息通知列表",
      requireAuth: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/supplyNotice.js